import { FC, useEffect } from 'react';

type Props = {
  title?: string;
  pageName?: string;
};

export const LightHelmet: FC<Props> = ({ title, pageName }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  useEffect(() => {
    if (pageName) {
      window.page_name = pageName;
    }
  }, []);

  return null;
};
